<template>
  <div id="app" @click.right="rightClick" class="bg">
    <VModal title="Create Component">
      <VForm
        :form="forms.createComponentForm"
        @onCancel="hideModal"
        @onCreate="({values})=>onMakeComponent(values)"
      />
    </VModal>
    <Layout>
      <div class="main-grid h-full">
        <div class="topbar">
          <div class="flex p-1 justify-end">
            <input
              type="text"
              :value="this.name"
              @change="(event)=> this.setName(event.target.value)"
              class="form-control"
              placeholder="Component name"
              @keyup.enter="(event)=>onRename(event.target.value)"
            />
            <div>
              <button class="btn px-2 p-1 text-white text-xs" @click="createNew()">Save</button>
            </div>
            <div class="p-1 text-xs text-white flex">
              <div class="btn" @click="()=>this.undo()">Undo</div>
              <div class="btn" @click="()=>this.redo()">Redo</div>
            </div>
            <div class="flex-grow text-xs flex justify-end p-1">
              <div
                v-for="(item,i) of resolutions.tabs"
                :key="i"
                class="px-2 cursor-default mr-2"
                :class="resolutions.isSelected(item) ? 'bg-teal-600 text-white' : 'text-gray-600 '"
                @click="()=>{resolutions.select(item);  onChangeSize()}"
              >{{item}}</div>
              <select class="btn text-white" @change="onChangeSize()" v-model="percentModel">
                <option v-for="(item,i) of percent.tabs" :key="i" :value="item">{{item}}%</option>
              </select>
            </div>
          </div>
          <VTabs :tabs="tabs" @change="(item)=> this.tab=item">
            <img src="../assets/html.png" class="h-4 mr-3" slot="Html" />
            <img src="../assets/logo.png" class="h-4 mr-3" slot="Vue" />
            <img src="../assets/react.webp" class="h-4 mr-3" slot="React" />
            <img src="../assets/angular.png" class="h-4 mr-3" slot="Angular" />
            <img src="../assets/unity.png" class="h-4 mr-3" slot="Unity" />
          </VTabs>
          <VClassList />
        </div>
        <div class="canvaspanel overflow-auto mt-4" style="height:80vh">
          <div :hidden="!(tab=='Design')" class>
            <div
              contenteditable="true"
              id="wrapper"
              ref="wrapper"
              :style="{zoom:zoomPercent+'%', width:screenWidth+'px', minHeight:screenHeight+'px'}"
              class="relative absolute m-auto bg-white border border-gray-400 cursor-default"
              @keydown="onChangeContent"
            ></div>
          </div>
          <div v-if="tab !== 'Design'" class="w-full relative">
            <div class="flex items-center justify-between sticky top-0 z-50 w-full">
              <a
                id="download_link"
                class="text-white btn flex justify-center items-center w-48"
                @click="downloadCode()"
                :download="filename"
                href
              >
                <DownloadIcon size="12" class="mr-2" />
                <div>Download {{this.tab}}</div>
              </a>
              <div v-if="tab!='Html'" class="flex items-center bg-gray-800">
                <div class="text-xs p-2 text-white">Install dependency before use</div>
                <em class="text-xs p-1 px-2 bg-gray-300 rounded mx-2">npm install tailwindcss</em>
              </div>
            </div>
            <codemirror :option="{height:350}" class="w-full mt-2" :value="code()"></codemirror>
          </div>
        </div>
      </div>
      <ContextMenu
        ref="contextMenu"
        :hidden="!contextMenu.isSelected"
        class="transition-all duration-200 absolute"
        @click="conextMenuOnClick"
      />
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import { UUID, UiSelect, UiTabs } from "@/util";
import { mapState, mapGetters, mapActions } from "vuex";
import firebase, { firestore } from "firebase";
import { AppService } from "../store";
import { Component } from "../store/models/component.model";
import { modalMixin } from "./../mixins";

export default {
  name: "Home",
  data() {
    return {
      isDown: false,
      isMouseDownForResize: false,
      tabs: ["Design", "Html", "Vue", "React", "Angular", "Unity"],
      tab: "Design",
      isPreview: false,
      contextMenu: new UiSelect(),
      resolutions: new UiTabs(["1440x900", "1920x1080"]),
      percent: new UiTabs(["100", "75", "50", "25"]),
      percentModel: "75",
      cntrlIsPressed: false,
      text: "",
      filename: "code.html",
      makeComponentName: ""
    };
  },
  mixins: [modalMixin],
  created() {},
  mounted() {
    this.setTailwind(this.getTailwind());
    document.onmousemove = this.documentMouseMove;
    document.onmousedown = this.documentMouseDown;
    document.onmouseup = this.documentMouseUp;
    document.onclick = this.documentOnClick;
    document.onkeyup = this.copyPaste;

    this.$nextTick().then(() => {
      const wrapper = this.$refs.wrapper;
      wrapper.onmousedown = this.onMouseDown;
      wrapper.onmouseup = this.onMouseUp;
      wrapper.onclick = this.itemOnMouseDown;
      window.onkeyup = this.onKeyUp;
      window.onkeydown = this.onKeyDown;
      this.setRootNode(wrapper);
    });
    this.fetchComponents();
    this.onChangeSize();
  },
  computed: {
    ...mapGetters([
      "selectedTool",
      "rootNode",
      "selectedComponent",
      "selectedNodeClassList",
      "zoomPercent",
      "screenWidth",
      "screenHeight",
      "name",
      "components",
      "selectedNodes"
    ]),
    ...mapState(["copyValue", "forms"])
  },
  methods: {
    ...mapActions([
      "selectNode",
      "deleteNode",
      "setStyles",
      "setTailwind",
      "setRootNode",
      "copy",
      "paste",
      "fetchComponents",
      "setSize",
      "setName",
      "updateComponentLocal",
      "createNewComponent",
      "setImages",
      "selectComponent",
      "selectNextSibling",
      "selectChildren",
      "selectParent",
      "selectPreviousSibling"
    ]),
    async signUp() {
      try {
        const resp = firebase
          .auth()
          .createUserWithEmailAndPassword("mk.work.se@gmail.com", "Salam123");
        console.log(resp);
      } catch (error) {
        console.error("ERORR", error);
      }
    },
    documentOnClick(event) {
      this.contextMenu.deSelect();
    },
    documentMouseDown() {
      this.isMouseDownForResize = true;
    },
    documentMouseUp() {
      this.isMouseDownForResize = false;
    },
    documentMouseMove(event) {
      try {
        const posttion =
          this.$refs.wrapper.offsetTop + this.$refs.wrapper.offsetHeight;
        if (this.isMouseDownForResize) {
          if (event.y >= posttion - 20 && event.y <= posttion + 20) {
            this.$refs.wrapper.setHeight(
              event.y - this.$refs.wrapper.offsetTop
            );
          }
        }
        if (event.y >= posttion - 20 && event.y <= posttion + 20) {
          document.body.classList.add("cursor-resize");
          this.$refs.wrapper.style.borderBottom = "1px #78B0FF solid";
        } else {
          document.body.classList.remove("cursor-resize");
          this.$refs.wrapper.style.borderBottom = "1px solid #ccc";
        }
      } catch (error) {}
    },
    rightClick(event) {
      event.preventDefault();
      this.$refs.contextMenu.$el.setPosition(event.x, event.y);
      this.contextMenu.select();
    },
    copyPaste(event) {
      if (event.ctrlKey && event.key == "c") {
        this.copy();
      } else if (event.ctrlKey && event.key == "v") {
        this.paste();
      }
    },
    code() {
      if (this.$refs && this.$refs.wrapper) {
        if (this.tab === "Html") {
          this.filename = `${this.selectedComponent.name}.html`;
          return this.rootNode.toHtml(this.selectedComponent.name);
        } else if (this.tab === "Vue") {
          this.filename = `${this.selectedComponent.name}.vue`;
          return this.rootNode.toVue(this.selectedComponent.name);
        } else if (this.tab === "React") {
          this.filename = `${this.selectedComponent.name}.jsx`;
          return this.rootNode.toReact(this.selectedComponent.name);
        } else if (this.tab === "Angular") {
          this.filename = `${this.selectedComponent.name}.component.ts`;
          return this.rootNode.toAngular(this.selectedComponent.name);
        }
      }
    },
    getTailwind() {
      const sheetList = Array.from(window.document.styleSheets);
      const tailwindCssRules = sheetList.find(item => {
        const rules = Array.from(item.rules);
        if (rules.some(item => item.selectorText === ".bg-red-600"))
          return true;
        else {
          return false;
        }
      });
      const tailwind = Array.from(tailwindCssRules.rules)
        .map(item => item.selectorText)
        .filter(item => item && item.includes("."));
      return tailwind.reduce((prev, curr) => {
        const key = curr.split("-")[0];
        if (prev[key]) {
          prev[key].push(curr.split(".")[1]);
          return { ...prev };
        } else {
          return { ...prev, [key]: [] };
        }
      }, {});
    },
    getColor(bgs, lab) {
      return bgs.reduce((prev, curr) => {
        const split = curr.split("-");
        let label = "";
        try {
          if (split[0] !== "border") {
            label = split[2] && +split[2] < 1000 ? lab + "-" + split[1] : lab;
          } else {
            if (split.length >= 3) {
              if (typeof +split[2] === "number") {
                label =
                  split[2] && +split[2] < 1000 ? lab + "-" + split[1] : lab;
              } else if (typeof +split[3] === "number") {
                label =
                  split[3] && +split[3] < 1000 ? lab + "-" + split[1] : lab;
              }
            } else {
              label = lab;
            }
          }
        } catch (error) {
          console.error("hey", error);
        }

        if (prev[label]) {
          prev[label].push(curr);
          return { ...prev };
        } else {
          prev[label] = [curr];
          return { ...prev };
        }
      }, {});
    },
    parseTailwind() {
      const tailwind = this.getTailwind();
      if (tailwind) {
        const obj = {
          Size: {
            WidthFixed: tailwind[".w"]
              .map(w => w.replace("\\", ""))
              .filter(item => !item.includes("/")),
            Height: tailwind[".h"].map(w => w.replace("\\", "")),
            WidthPercent: tailwind[".w"]
              .map(w => w.replace("\\", ""))
              .filter(item => item.includes("/"))
          },
          Flex: {
            Flex: ["flex", ...tailwind[".flex"]],
            Justify: [...tailwind[".justify"]],
            FlexItems: [...tailwind[".items"]],
            Self: [...tailwind[".self"]]
          },
          Design: {
            Background: this.getColor(tailwind[".bg"], "Bg"),
            Shadow: tailwind[".shadow"],
            Rounded: tailwind[".rounded"],
            Border: this.getColor(tailwind[".border"], "Border")
          },
          Text: {
            Text: this.getColor(tailwind[".text"], "Text"),
            Font: tailwind[".font"]
          },
          Margin: {
            Mar: tailwind[".m"],
            MarX: tailwind[".mx"],
            MarY: tailwind[".my"],
            MarT: tailwind[".mt"],
            MarL: tailwind[".ml"],
            MarR: tailwind[".mr"]
          },
          Padding: {
            Pad: tailwind[".p"],
            PadX: tailwind[".px"],
            PadY: tailwind[".py"],
            PadT: tailwind[".pt"],
            PadL: tailwind[".pl"],
            PadR: tailwind[".pr"]
          }
        };
        return obj;
      } else {
        return {};
      }
    },
    onMouseDown(event) {
      if (event.button == 0) {
        this.isDown = true;
      }
    },
    onMouseUp(mouseButton) {
      this.isDown = false;
    },
    itemOnMouseDown(event) {
      this.selectNode({ isMulti: this.cntrlIsPressed, node: event.target });
    },
    onKeyDown(event) {
      // console.log(event);
      // Multi Select =  ⌘ + Click
      if (event.which == "91" || event.which == "17") {
        event.preventDefault();
        this.cntrlIsPressed = true;
      }

      //  ⌘ + A => Select All
      if (event.which == "65" && event.metaKey) {
        event.preventDefault();
        this.selectChildren({ parentNode: [this.selectedNodes[0].parentNode] });
      }

      //  ⌘ + ->  = Select Next Sibling Multi
      if (event.which == "39" && event.metaKey) {
        event.preventDefault();
        this.selectNextSibling();
      } else if (event.which == "39") {
        // Select Next Sibling  => Right Arrow
        event.preventDefault();
        this.selectNextSibling({ isMulti: false });
      }

      if (event.which == "37" && event.metaKey) {
        event.preventDefault();
        this.selectPreviousSibling();
        // this.selectChildren({ parentNode: [this.selectedNodes[0].parentNode] });
      } else if (event.which == "37") {
        // Select All Siblings => ⌘ + Left Arrow
        event.preventDefault();
        this.selectPreviousSibling({ isMulti: false });
      }

      // Select Parent => ⌘ + Up Arrow
      if (event.which == "38") {
        event.preventDefault();
        this.selectParent({ children: this.selectedNodes });
      }

      // Select All Children = ⌘ + Down Arrow
      if (event.which == "40") {
        event.preventDefault();
        this.selectChildren({ parentNode: this.selectedNodes });
      }
    },
    onKeyUp() {
      this.cntrlIsPressed = false;
    },
    onPeviewToggle() {},
    onChangeSize() {
      const [width, height] = this.resolutions.tab.split("x");
      this.setSize({
        width: +width,
        height: +height,
        percent: this.percentModel
      });
    },
    createNew() {
      this.createNewComponent({ name: this.name });
    },
    onChangeContent(event) {
      this.updateComponentLocal(true);
    },
    downloadCode() {
      const code = this.code();
      var data = new Blob([code], { type: "text/plain" });
      var url = window.URL.createObjectURL(data);
      document.getElementById("download_link").href = url;
    },
    conextMenuOnClick(item) {
      if (item === "Make Component") {
        this.showModal();
      }
    },
    onMakeComponent({ name }) {
      this.createNewComponent({
        name,
        code: this.selectedNodes[0]
      }).then(({ component }) => {
        this.hideModal();
      });
    }
  }
};
</script>

<style  scoped>
.bg-check {
  background: url("./../assets/check.jpg");
  background-size: 100px;
}

.topbar {
  grid-area: topbar;
}

.canvaspanel {
  grid-area: canvaspanel;
}

.main-grid {
  display: grid;
  grid-template-rows: 5.5rem auto;
  grid-template-areas: "topbar" "canvaspanel";
}

.main-grid > div {
  /* border: 1px dashed orange; */
}

/* bg-none mr-1 px-2 p-1 bg-gray-300 border-gray-600 text-xs text-gray-600 focus:text-gray-900 focus:font-bold focus:outline-none focus:border-none focus:border-blue-600 */
</style>